import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';

import query, { MyCollectionsQuery } from './my-collections.graphql';
import CollectionRow from './collection-row/collection-row';

interface Props {
    imageId: string;
    onClose: () => void;
}

class MyCollections extends React.PureComponent<Props> {
    render() {
        const { imageId, onClose } = this.props;

        return (
            <Query<MyCollectionsQuery> query={query} variables={{ imageId }}>
                {({ loading, data }) =>
                    data && data.collections && data.collections.edges ? (
                        <LoadingWrapperView loading={loading}>
                            {data.collections.edges.map(edge =>
                                edge && edge.node ? (
                                    <CollectionRow
                                        key={edge.node.id}
                                        {...edge.node}
                                        imageId={imageId}
                                        onClose={onClose}
                                    />
                                ) : null
                            )}
                        </LoadingWrapperView>
                    ) : null
                }
            </Query>
        );
    }
}

export default Styled({})(MyCollections);
